import { AUTHED_INFOR_LOCAL_STORAGE, JWT_TOKEN_LOCAL_STORAGE, REFRESH_TOKEN_LOCAL_STORAGE } from '@const/auth'
import axios, { AxiosInstance } from 'axios'
import { apiEndpointBaseUrl, apiVersion } from '@environments/environment'
import { get, remove, set } from '@services/local-storage-service'
import { error } from '@services/toast-service'
import { removeAppErrByNames, setAppErr } from '@store/StaticStore/appSlice'
import { ERR_LOGIN, ERR_NETWORK } from '@const/error'
import { authApi } from '@services/api'
import { store } from './configStore'
import { removeAuth } from './removeAuth'

export class CustomAxios {
  API: AxiosInstance

  isRequestErr: boolean

  constructor () {
    this.API = axios.create({
      baseURL: `${apiEndpointBaseUrl}/api/${apiVersion}`
    })

    this.isRequestErr = false

    this.API.interceptors.request.use(
      config => {
        const jwtToken = get(JWT_TOKEN_LOCAL_STORAGE)

        if (!jwtToken) {
          return config
        }

        const newConfig = {
          ...config,
          headers: {
            Authorization: `Bearer ${jwtToken}`
          }
        }
        return newConfig
      },
      err => {
        if (!err.status) {
          err(err.response.statusText)
          // window.location.replace('/login')
        }
      }
    )

    this.API.interceptors.response.use(
      response => {
        if (!response?.data) {
          error(`Data is undefined :: [${response.config.url}]`)
          return response
        }
        const { errors, statusCode } = response.data as ApiResponse
        if (statusCode! >= 400 && errors?.length) {
          // error('どこかに故障があります。') // Something wrong
          error(errors.join())
          console.error(errors)
        }

        if (this.isRequestErr) {
          store.dispatch(removeAppErrByNames([ERR_LOGIN, ERR_NETWORK]))
        }

        return response
      },
      async err => {
        this.isRequestErr = true
        if (!err.response) {
          error('どこかに故障があります。')
          console.error('Network error')
          store.dispatch(setAppErr({
            isError: true,
            msg: '',
            name: ERR_NETWORK
          }))
          return
        }
        const { statusText, status, data } = err.response
        const msg = data?.message ? data.message : statusText
        if (status === 401) {
          const refeshToken = get(REFRESH_TOKEN_LOCAL_STORAGE)
          if (refeshToken) {
            try {
              const res = await axios.post<TAuthDetail.State['informationAuthed']>(`${this.API.defaults.baseURL}${authApi.prefix}/RefreshToken`, undefined, {
                headers: {
                  refreshToken: refeshToken
                }
              })
              if (res?.data) {
                const originalRequest = err.config
                const { jwtToken, refreshToken, ...anotherInfor } = res.data
                set(JWT_TOKEN_LOCAL_STORAGE, jwtToken)
                set(REFRESH_TOKEN_LOCAL_STORAGE, refreshToken)
                set(AUTHED_INFOR_LOCAL_STORAGE, anotherInfor)
                axios.defaults.headers.common.Authorization = `Bearer ${jwtToken}`
                originalRequest.headers.Authorization = `Bearer ${jwtToken}`
                // eslint-disable-next-line consistent-return
                return axios(originalRequest)
              }
            } catch (errRefreshToken) {
              // removeAuth()
              console.log('refresh token', errRefreshToken)
              // error('どこかに故障があります。')
              // localStorage.clear()
              remove(JWT_TOKEN_LOCAL_STORAGE)
              remove(REFRESH_TOKEN_LOCAL_STORAGE)
              remove(AUTHED_INFOR_LOCAL_STORAGE)
              window.location.replace(`/login?fallBack=${window.location.href}${window.location.search}`)
              return
            }
          }

          removeAuth()
          // error('禁断') // Forbidden or unthorized
          // dispatch error
          store.dispatch(setAppErr({
            isError: true,
            msg: '',
            name: ERR_LOGIN
          }))
          setTimeout(() => {
            window.location.replace(`/login?fallBack=${window.location.href}${window.location.search}`)
          }, 1000)
          return
        }
        console.error(msg)
        error(msg) // Something wrong
      }
    )
  }
}

const customAxios = new CustomAxios()
export const { API } = customAxios
